import { createBrowserClient } from "@supabase/ssr";

import type { Database } from "@/types/database.types";

let client: ReturnType<typeof createBrowserClient<Database>> | null = null;

export function getSupabaseClient() {
  const url = import.meta.env.VITE_SUPABASE_URL;
  const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

  if (!url || !anonKey) {
    throw new Error("Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY");
  }

  if (!client) {
    client = createBrowserClient<Database>(url, anonKey);
  }

  return client;
}

/** Async for repository compatibility (formerly server client). */
export async function createClient() {
  return getSupabaseClient();
}
